import styles from "./styles.module.scss";

export const Button = ({ className = '', variant, ...props }) => {
  const variantClass = variant === 'walky' ? styles.walky : '';

  return (
    <button
      {...props}
      className={`${styles.button} ${variantClass} ${className}`.trim()}
    >
      {props.children}
    </button>
  );
};
